import type {
  ColDef,
  ICellRendererParams,
  SortModelItem
} from 'ag-grid-enterprise';

import type { VulnerabilityType } from '@/pages/VulnerabilityManagement/VulnerabilityManagement.types';

import {
  vulnerabilityAssetNameCell,
  vulnerabilityCVECell,
  vulnerabilityDateRemediatedCell,
  vulnerabilityDescriptionCell,
  vulnerabilityNameExploitedCell,
  vulnerabilityPonduranceScoreCell,
  vulnerabilityRemediatedCell,
  vulnerabilitySeverityCell,
  vulnerabilityTotalAssetsCell
} from './VulnerabilitiesTable.renderers';

export const VULNERABILITIES_TABLE_DEFAULT_SORT_MODEL: SortModelItem[] = [
  {
    colId: 'name',
    sort: 'asc'
  }
];

export const getVulnerabilityColumnDefs = (
  tableLocation: 'asset' | 'vulnerabilities-tab',
  groupByVulnerabilities: boolean
): ColDef<VulnerabilityType>[] => {
  const hideRemediationColumns = tableLocation === 'vulnerabilities-tab';

  const columns: ColDef<VulnerabilityType>[] = [
    {
      field: 'cve',
      headerName: 'CVE',
      width: 250,
      cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
        vulnerabilityCVECell(params.data as VulnerabilityType)
    },
    {
      field: 'name',
      headerName: 'Vulnerability Name',
      width: 250,
      cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
        vulnerabilityNameExploitedCell(params.data as VulnerabilityType)
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
        vulnerabilityDescriptionCell(params.data as VulnerabilityType)
    },
    {
      colId: 'cvss',
      headerName: 'CVSS Severity',
      width: 150,
      cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
        vulnerabilitySeverityCell(params.data as VulnerabilityType)
    },
    {
      field: 'vmp_exposure_index',
      headerName: 'Pondurance Score',
      width: 175,
      cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
        vulnerabilityPonduranceScoreCell(params.data as VulnerabilityType)
    },
    {
      field: 'remediated',
      headerName: 'Remediated',
      width: 175,
      hide: hideRemediationColumns,
      suppressColumnsToolPanel: true,
      cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
        vulnerabilityRemediatedCell(params.data as VulnerabilityType)
    },
    {
      field: 'date_remediated',
      headerName: 'Remediated At',
      suppressColumnsToolPanel: true,
      width: 150,
      hide: hideRemediationColumns,
      cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
        vulnerabilityDateRemediatedCell(params.data as VulnerabilityType)
    }
  ];

  columns.push(
    groupByVulnerabilities
      ? {
          field: 'asset_count',
          headerName: 'Assets',
          width: 200,
          cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
            vulnerabilityTotalAssetsCell(params.data as VulnerabilityType)
        }
      : {
          colId: 'vmp_asset_name',
          headerName: 'Asset',
          width: 200,
          cellRenderer: (params: ICellRendererParams<VulnerabilityType>) =>
            vulnerabilityAssetNameCell(params.data as VulnerabilityType)
        }
  );

  return columns;
};

export default getVulnerabilityColumnDefs;
